
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { ModifyBreaktime, Breaktime, PostBreaktime } from 'interfaces/breaktime.interface';
import { API } from 'constants/api.contants';


export class BreaktimeService {

  static getBreaktimeById(
    breaktimeId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Breaktime> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.BREAKTIME}/${breaktimeId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Breaktime> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getBreaktimesByTimeGridId(
    timeGridId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Breaktime[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.BREAKTIME_BY_TIMEGRID}/${timeGridId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Breaktime[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( breaktime => { return { ...breaktime }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static putBreaktime(
    breaktimeId: string,
    breaktime: ModifyBreaktime,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      AXIOS.put( `${API.BREAKTIME}/${breaktimeId}`, breaktime, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static postBreaktime(
    breaktime: PostBreaktime,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ id: string }> {
    return new Promise( async resolve => {
      AXIOS.post( API.BREAKTIME, breaktime, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ id: string }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static deleteBreaktime(
    breaktimeId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.BREAKTIME}/${breaktimeId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};